import { useState } from 'react';
import Button from '@/components/ui/Button';

export default function TestPage() {
  const [apiResults, setApiResults] = useState<any>({});

  const testApi = async (endpoint: string, name: string) => {
    try {
      console.log(`Testing ${endpoint}...`);
      const response = await fetch(`/api/${endpoint}`);
      const data = await response.json();
      console.log(`${name} response:`, data);
      setApiResults((prev: any) => ({ ...prev, [name]: { status: response.status, data } }));
    } catch (error: any) {
      console.error(`${name} error:`, error);
      setApiResults((prev: any) => ({ ...prev, [name]: { error: error.message } }));
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">API Test Page</h1>
      
      <div className="space-y-4 mb-8">
        <Button onClick={() => testApi('accounting/summary', 'Accounting Summary')}>
          Test Accounting Summary
        </Button>
        <Button onClick={() => testApi('smart-ledger/entries', 'Smart Ledger Entries')}>
          Test Smart Ledger Entries
        </Button>
        <Button onClick={() => testApi('smart-ledger/accounts', 'Smart Ledger Accounts')}>
          Test Smart Ledger Accounts
        </Button>
        <Button onClick={() => testApi('expense-proof/expenses', 'Expense Proof Expenses')}>
          Test Expense Proof
        </Button>
        <Button onClick={() => testApi('document-vault/documents', 'Document Vault')}>
          Test Document Vault
        </Button>
        <Button onClick={() => testApi('business-profile/profile', 'Business Profile')}>
          Test Business Profile
        </Button>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-semibold">Results:</h2>
        {Object.entries(apiResults).map(([name, result]: [string, any]) => (
          <div key={name} className="border rounded p-4">
            <h3 className="font-semibold mb-2">{name}</h3>
            {result.status && <p>Status: {result.status}</p>}
            {result.error && <p className="text-red-600">Error: {result.error}</p>}
            {result.data && (
              <pre className="bg-gray-100 p-2 rounded text-sm overflow-auto">
                {JSON.stringify(result.data, null, 2)}
              </pre>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
